<template>
  <section class="px-5">
    <TitleBlock :description="content.description" :title="content.title" class="text-center" />
    <ul
      class="flex justify-center flex-wrap gap-2.5 lg:gap-6 mt-10 max-w-300 mx-auto transition-[gap]"
    >
      <ImageCard
        v-for="card in content.items"
        :background="cardBackground"
        :content="card"
        :key="card.flexKey"
      />
    </ul>
  </section>
</template>

<script lang="ts">
import { TitleBlock } from "@/components/blocks";
import ImageCard from "@/components/cards/ImageCard.vue";

export default {
  name: "ImagesSection",
  components: { ImageCard, TitleBlock },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cardBackground(): background {
      return this.content.background.split("_")[1];
    },
  },
};
</script>
